import * as types from "../actions/types";



const initialState = {
  list: null,
  loading: false,
  adsById: null
};


export default function importing_photos(state = initialState, action) {
  switch (action.type) {
    case types.SET_IMPORTING_PHOTOS_LIST:
      return {
        ...state,
        usefulSiteslist: action.payload
      };
    case types.SET_IMPORTING_PHOTOS_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    default:
      return state;
  }
}